import { render, staticRenderFns } from "./CandidatePreview.vue?vue&type=template&id=a69ae820&scoped=true&"
import script from "./CandidatePreview.vue?vue&type=script&lang=js&"
export * from "./CandidatePreview.vue?vue&type=script&lang=js&"
import style0 from "./CandidatePreview.vue?vue&type=style&index=0&id=a69ae820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69ae820",
  null
  
)

export default component.exports